module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedBlack.80775a8.ttf";